var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"top-nav",class:_vm.classes},[_vm._t("default"),(_vm.isResponsive)?_c('a',{staticClass:"toggle-menu",on:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("☰")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }